import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription, combineLatestWith, of, mergeMap, tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JSONAtaObject } from 'src/app/features/shared/helper-classes';

/* data storage interface for ngrx */
import { DataStorage } from 'src/app/features/data-stores/data-storage.interface';

import * as lodash from 'lodash';

/* actions */
import { Logout } from 'src/app/features/data-stores/auth-data-store/state/auth-data-store.actions';

// prettier-ignore
// #region customCode: page-component-ts__package-import__end

// #endregion customCode: page-component-ts__package-import__end

@Component({
  selector: 'turplus-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit, OnDestroy {

  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__start
  
  // #endregion customCode: page-component-ts__ui-page-component-class__start

  
    /* Component: Image 4 */
    image_4: any = {
      source:"https://api.rapider.ai/project-files/get-file-content/679edc11-8aaa-493a-814d-b53de13b8c92",alternateText:"",placeholder:null,disablePreview:true,borderSettings:null,shadowSettings:null,paddingSettings:null,marginSettings:null,customSizeSettings:{"width":"100%","maxWidth":"100%","minWidth":null,"height":"20%","maxHeight":"20%","minHeight":null},};
  
    /* Component: Menu 6 */
    menu_6: any = {
      config:{"mode":"vertical","items":[
        {"label":"Turlar","actionBehavior":"router","redirectUrl":"/tours","level":"1","children":[],"isExpanded":false},
        {"label":"Yolcular","actionBehavior":"router","redirectUrl":"/clients","level":"1","children":[],"isExpanded":false},
        {"label":"Çıkış Yap","key":"logout","redirectUrl":"/auth/login","actionBehavior":"emit"}
      ],"backgroundColor":"#ffffff"},isCollapsed:false,paddingValue:"0px",menuPlacement:"center",isDisabled:null,showLabels:true,activeItem:null,currentSubmenuOnly:null,};
  
      /* 
              {"label":"Program","actionBehavior":"router","redirectUrl":"/daily-program-items","level":"1","children":[],"isExpanded":false},
        {"label":"Konaklama","actionBehavior":"router","redirectUrl":"/accommodations","level":"1","children":[],"isExpanded":false},
        {"label":"Ulaşım","actionBehavior":"router","redirectUrl":"/transportation","level":"1","children":[],"isExpanded":false},
      */

  /* state subscriptions */
  subscriptions: Subscription[];

  /* visibility condition variables */
  

  constructor(
    private store: Store<DataStorage>
  ) {
    // prettier-ignore
    // #region customCode: page-component-ts__constructor__start
    
    // #endregion customCode: page-component-ts__constructor__start

    // prettier-ignore
    // #region customCode: page-component-ts__constructor__end
    
    // #endregion customCode: page-component-ts__constructor__end
  }

  ngOnInit(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__start
    
    // #endregion customCode: page-component-ts__ui-page-on-init__start

    this.subscribeToData();
    this.subscribeToDataSelectors();

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-init__end
    
    // #endregion customCode: page-component-ts__ui-page-on-init__end
  }

  ngOnDestroy(): void {
    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__start
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__start
    
    this.subscriptions?.forEach(subscription => subscription.unsubscribe());

    // prettier-ignore
    // #region customCode: page-component-ts__ui-page-on-destroy__end
    
    // #endregion customCode: page-component-ts__ui-page-on-destroy__end
  }

  subscribeToData() {
    this.subscriptions = [
      ];
  }

  subscribeToDataSelectors() {
    const dataSelectors = [
      
    ];
    this.subscriptions.push(...dataSelectors);
  }

  
  menu_6_menuItemClick(output: any) {
        of(
            JSONAtaObject.chain(output)
          ).pipe(
            tap(payloadAsJsonataObj => {
              /* get value of the passed jsonata object */
              const payload = <any>payloadAsJsonataObj.value;
              /* dispatch events */
              this.store.dispatch(Logout());
            }),
          ).subscribe();
        }
    
  // prettier-ignore
    // #region customCode: page-component-ts__ui-page-component-class__end
    
    // #endregion customCode: page-component-ts__ui-page-component-class__end
}
